<select
  id="combo_mc"
  class="{{ initOptions.style }}"
  name="{{ initOptions.id }}"
  [ngStyle]="{
    width: initOptions.width + 'px',
    height: initOptions.height + 'px'
  }"
>
  <option
    id="combClass-{{i}}"
    *ngFor="let choice of initOptions.options; let i = index"
  >
    {{ choice }}
  </option>
</select>
